<template>
  <div>
    <form @submit.prevent="onSubmit" @reset="onReset">
      <div class="row">
        <div class="col-sm-4">
            <span class="span-title">
              {{ $t('orders.status') }}
            </span>
            <select
                id="status"
                v-model="status"
                class="form-select form-select-sm"
            >
                <option :value="-1">{{ $t('orders.select_status') }}</option>
                <option :value="0">{{ $t('inspection.options.open') }}</option>
                <option :value="2">{{ $t('inspection.options.okay') }}</option>
                <option :value="3">{{ $t('inspection.options.defects') }}</option>
                <option :value="4">{{ $t('inspection.options.ban') }}</option>
            </select>
        </div>
        <div class="col-sm-4">
            <span class="span-title">
              {{ $t('orders.create_time') }} - {{ $t('trip_list.road_sec_from') }}
            </span>
            <input
                id="start"
                v-model="fromDate"
                type="date"
                class="form-control form-control-sm"
            />
        </div>
        <div class="col-sm-4">
            <span class="span-title">
              {{ $t('orders.create_time') }} - {{ $t('trip_list.road_sec_to') }}
            </span>
            <input
                id="end"
                v-model="toDate"
                type="date"
                class="form-control form-control-sm"
            />
        </div>
      </div>
      <div class="col-sm-12 d-flex justify-content-end">
        <button type="submit" class="btn btn-primary form-button">
          {{ $t('ins_report.search') }}
        </button>
        <button type="reset" class="btn btn-danger form-button">
          {{ $t('ins_report.clear') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {timeUtils} from '../../mixins/TimeUtils'

export default {
    name: 'SingleVehicleDefectSearch',
    mixins: [restApi, timeUtils],
    props: {
        vehicle: {
            type: Object
        }
    },
    data: function () {
        return {
            status: 0,
            fromDate: null,
            toDate: null,
        }
    },
    methods: {
        onSubmit: function () {
            var params = {}
            if (this.status >= 0) {
                params.status = this.status
            }
            params.vehicle = this.vehicle.id
            if (this.fromDate !== null && this.fromDate.trim()) {
                params.dateFrom = this.localTimeToUtcTime(this.fromDate).getTime()
            }
            if (this.toDate !== null && this.toDate.trim()) {
                params.dateTo = this.getEndOfTheDay(this.toDate).getTime()

            }
            this.$emit('search', params)
        },

        onReset: function () {
            this.status = 0
            this.fromDate = null
            this.toDate = null
        }
    }
}
</script>

<style scoped>

</style>
